// src/pages/Moderation/ModerationQueuePage/model/useModerationQueue.ts
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import {
  getModerationChannelsRequest,
  getModerationFlagsRequest,
  getModerationReportsCountersRequest,
  getModerationReportsRequest,
} from 'redux/reducers/moderation/reducer';

import {
  getModerationCountersSelector,
  getModerationFlagsSelector,
  getModerationLoaderSelector,
  getModerationReportsSelector,
} from 'redux/reducers/moderation/selectors';

import { normalizeTab, tabToQuery } from './tabToQuery';
import { ModerationQueueFilter, PaginationState } from './types';

export function useModerationQueue() {
  const dispatch = useDispatch();
  const { tab: tabParam } = useParams<{ tab: string }>();

  const tab = useMemo(() => normalizeTab(tabParam), [tabParam]);

  const counters = useSelector(getModerationCountersSelector);
  const reports = useSelector(getModerationReportsSelector);
  const flags = useSelector(getModerationFlagsSelector);
  const loader = useSelector(getModerationLoaderSelector);

  const [pagination, setPagination] = useState<PaginationState>({ page: 1, perPage: 20 });
  const [filters, setFilters] = useState<ModerationQueueFilter>({});

  // первинні довідники
  useEffect(() => {
    dispatch(getModerationReportsCountersRequest());
    dispatch(getModerationFlagsRequest());
    dispatch(getModerationChannelsRequest({ current_page: 1, per_page: 10 }));
  }, [dispatch]);

  // коли змінюються фільтри — скидаємо page на 1 (щоб не попадати на порожню сторінку)
  useEffect(() => {
    setPagination((p) => ({ ...p, page: 1 }));
  }, [filters]);

  // основний запит reports
  useEffect(() => {
    const { approved, on_moderation } = tabToQuery(tabParam);

    dispatch(
      getModerationReportsRequest({
        current_page: pagination.page,
        per_page: pagination.perPage,
        ...filters,

        approved,
        on_moderation,
        has_restriction: true,

        // як у тебе було:
        // restricted: true,
      }),
    );
  }, [dispatch, tabParam, pagination.page, pagination.perPage, filters]);

  return {
    tab,
    counters,
    reports,
    flags,
    loader,
    pagination,
    setPagination,
    filters,
    setFilters,
  };
}
